<template>
  <div class="tags-input">
    <template v-for="tag in fields">
      <template v-if="tag.type === TagType.multiselect || tag.type === TagType.select">

        <tag-input
          :label="tag.label"
          :options="tag.options"
          :type="tag.type"
          v-bind:key="tag.id"
          v-model="value[tag.id]">
        </tag-input>

      </template>
      <template v-else-if="tag.type === TagType.boolean">

        <fieldset v-bind:key="tag.id">
          <input-yes-no
            :label="tag.label"
            v-model="value[tag.id]">
          </input-yes-no>
        </fieldset>

      </template>
      <template v-else-if="tag.type === TagType.text">

        <fieldset v-bind:key="tag.id">
          <input-with-validation
            type="text"
            :label="tag.label"
            v-model="value[tag.id]">
          </input-with-validation>
        </fieldset>

      </template>
      <template v-else-if="tag.type === TagType.longtext">

        <fieldset v-bind:key="tag.id">
          <input-with-validation
            type="textarea"
            :label="tag.label"
            v-model="value[tag.id]">
          </input-with-validation>
        </fieldset>

      </template>
    </template>
  </div>
</template>

<script>
  import { TagType } from '../services/BookingDetailsProvider'
  import tagInput from './tagInput'
  import inputCheckbox from './inputCheckbox'
  import inputWithValidation from './inputWithValidation'
  import inputYesNo from './inputYesNo'

  export default {
    name: 'tagsInput',
    props: [
      'fields',
      'value'
    ],
    data () {
      return {
        TagType
      }
    },
    components: {
      tagInput,
      inputCheckbox,
      inputYesNo,
      inputWithValidation
    }
  }
</script>



// WEBPACK FOOTER //
// tagsInput.vue?4a821d88